import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

const QUERY = gql`
  query plan($date: String) {
    plan(date: $date) {
      id
      date
      meal
      amount
      unit {
        name
        sign
      }
      user {
        email
      }
      dish {
        id
        name
        recipe
      }
    }
  }
`;

const usePlan = (date) => {
  const { loading, error, data, refetch } = useQuery(QUERY, {
    variables: { date },
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  return { loading, error, refetch, data: data?.plan };
};

export default usePlan;
